import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@mui/material';

function StringInput({
  value,
  onChange,
  disabled,
  readOnly,
  maxLength,
  errored,
  password,
  id,
  margin,
  placeholder,
  startAdornment,
  endAdornment,
}) {
  const onChangeHandler = useCallback(
    (e) => {
      const newValue = e.target.value;
      if (!readOnly && (!maxLength || newValue.length <= maxLength)) {
        onChange(e, newValue);
      }
    },
    [maxLength, onChange, readOnly],
  );
  const type = password ? 'password' : 'text';
  return (
    <Input
      id={id}
      value={value || ''}
      onChange={onChangeHandler}
      disabled={disabled}
      error={errored}
      readOnly={readOnly}
      type={type}
      margin={margin}
      fullWidth
      placeholder={placeholder}
      startAdornment={startAdornment}
      endAdornment={endAdornment}
    />

  );
}
StringInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number,
  errored: PropTypes.bool,
  password: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
  placeholder: PropTypes.string,
  startAdornment: PropTypes.symbol,
  endAdornment: PropTypes.symbol,
};

StringInput.defaultProps = {
  id: null,
  value: '',
  disabled: false,
  readOnly: false,
  maxLength: 0,
  errored: false,
  password: false,
  margin: 'dense',
  placeholder: null,
  startAdornment: null,
  endAdornment: null,
};

export default memo(StringInput);
